import {cn} from "@/lib/cn"

/** Brand glyphs in public/icons — the same files dized-next beta2 serves. */
export type DizedIconName =
  | "ages"
  | "copy-link"
  | "extras"
  | "hourglass"
  | "log-stats"
  | "players"
  | "rules"
  | "tutorial"

/**
 * A brand glyph, drawn as a `currentColor` mask.
 *
 * The source SVGs ship a fixed `#4a4a4a` fill with identical light and dark
 * variants, so masking is the only way to make them follow the theme. Size it
 * with a `size-*` utility. Omit `label` when the icon sits beside its own text.
 */
export const DizedIcon = ({
  name,
  label,
  className,
}: {
  name: DizedIconName
  label?: string
  className?: string
}) => {
  const mask = `url(/icons/${name}.svg)`
  const style = {
    maskImage: mask,
    WebkitMaskImage: mask,
    maskRepeat: "no-repeat",
    WebkitMaskRepeat: "no-repeat",
    maskPosition: "center",
    WebkitMaskPosition: "center",
    maskSize: "contain",
    WebkitMaskSize: "contain",
  }
  const classes = cn("inline-block size-[1em] shrink-0 bg-current", className)
  return label === undefined ? (
    <span aria-hidden className={classes} style={style} />
  ) : (
    <span role="img" aria-label={label} className={classes} style={style} />
  )
}
